import React from 'react';

import { Icon, IconButton } from '@atom/mui';
import { pluralize } from '@atom/utilities/stringUtilities';

import classes from './drawerContent.module.css';

interface Props {
  actionIcon?: React.ReactNode;
  showActionButton?: boolean;
  actionOnClick?: () => void;
  actionTooltip?: string;
  count: number;
  label: string;
  open: boolean;
  toggle: () => void;
}

const ContentListHeader = ({
  actionIcon,
  actionOnClick,
  actionTooltip,
  showActionButton = true,
  count,
  label,
  open,
  toggle,
}: Props) => {
  if (count === 0) {
    return null;
  }
  const title = pluralize(count, label);
  return (
    <div className={classes.drawerContentListHeader}>
      <div className={classes.drawerContentListHeaderTitle}>
        {count} {title}
      </div>
      <div className={classes.drawerContentListHeaderAction}>
        {actionIcon && showActionButton && (
          <IconButton
            edge="end"
            tooltip={actionTooltip}
            onClick={actionOnClick}
          >
            {actionIcon}
          </IconButton>
        )}
        <IconButton onClick={toggle}>
          <Icon>{open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
        </IconButton>
      </div>
    </div>
  );
};

export default ContentListHeader;
